'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { Animal } from 'shared/@generated/models';

export type AdAnimal = Animal | 'general';

const AdAnimalContext = createContext<AdAnimal>('general');

export function AdAnimalProvider({
  animal,
  children,
}: {
  animal?: Animal | null;
  children: ReactNode;
}) {
  return (
    <AdAnimalContext.Provider value={animal ?? 'general'}>{children}</AdAnimalContext.Provider>
  );
}

export function useAdAnimal(): AdAnimal {
  return useContext(AdAnimalContext);
}
